// =====================================================================================
// Delivery & Pickup 日付・時間帯の「×」クリア ＋ NaN / 「時間帯を指定しない」
// ＋ Add to Cart 直前に「このフォーム」の hidden / properties を補正
// ＋ × 時に cart attributes.product_* も NaN / 指定しない に上書き
// =====================================================================================
(function () {

  var NO_DATE_VALUE = 'NaN-aN-aN';         // お届け希望日 : NaN-aN-aN
  var NO_TIME_VALUE = '指定しない';     // ご希望の時間帯 : 指定しない
  var NO_DAY_VALUE  = '';                  // 曜日は空

  // Delivery & Pickup が使っていそうなストレージキーをざっくり掃除
  function clearDeliveryStorage() {
    ['localStorage', 'sessionStorage'].forEach(function (type) {
      var store;
      try {
        store = window[type];
      } catch (e) {
        return;
      }
      if (!store) return;

      try {
        var removeKeys = [];
        for (var i = 0; i < store.length; i++) {
          var key = store.key(i);
          if (!key) continue;
          if (/(delivery|identixweb|iwod|order-delivery)/i.test(key)) {
            removeKeys.push(key);
          }
        }
        removeKeys.forEach(function (k) {
          store.removeItem(k);
        });
      } catch (e) {
        // 読めないストレージは無視
      }
    });
  }

  // ---- 時間帯セレクトを強制的に「時間帯を指定しない」にする helper ----
  function forceSelectNoTimeOption(select) {
    if (!select) return;

    // セレクト本体（クリックするとドロップダウンが開く部分）
    var selector = select.querySelector('.ant-select-selector');
    if (!selector) return;

    try {
      // ドロップダウンを開く（Ant Design 系の挙動に合わせて mousedown + click）
      var downEv = new MouseEvent('mousedown', { bubbles: true, cancelable: true });
      selector.dispatchEvent(downEv);
      var clickEv = new MouseEvent('click', { bubbles: true, cancelable: true });
      selector.dispatchEvent(clickEv);
    } catch (e) {
      selector.click();
    }

    // 少し待ってから、表示中のドロップダウンから「時間帯を指定しない」を探して click
    setTimeout(function () {
      try {
        var dropdowns = document.querySelectorAll('.ant-select-dropdown');
        for (var i = 0; i < dropdowns.length; i++) {
          var dd = dropdowns[i];
          var style = window.getComputedStyle(dd);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
            continue; // 非表示はスキップ
          }

          var opts = dd.querySelectorAll('.ant-select-item-option');
          for (var j = 0; j < opts.length; j++) {
            var txt = (opts[j].textContent || '').trim();
            if (!txt) continue;

            if (
              txt.indexOf('時間帯を指定しない') !== -1 ||
              txt.indexOf('指定しない') !== -1
            ) {
              opts[j].click(); // これでアプリ側の「選択値」が本当に切り替わる

              try {
                select.classList.add('ev-no-time');
              } catch (e) {}

              return;
            }
          }
        }
      } catch (err) {
        if (window.console && console.warn) {
          console.warn('forceSelectNoTimeOption failed', err);
        }
      }
    }, 50);
  }

  // ---- 🔑 cart attributes.product_* を「NaN / 指定しない」に書き換える ----
  function rewriteCartProductAttributesToNone() {
    if (!window.fetch) return;

    try {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (cart) {
          if (!cart || !cart.attributes) return;

          var attrs = {};
          var has = false;

          for (var key in cart.attributes) {
            if (!Object.prototype.hasOwnProperty.call(cart.attributes, key)) continue;

            var value = cart.attributes[key];

            if (/^product_/.test(key)) {
              // フォーマット: 「商品名 |&| 日付 |&| 曜日 |&| 時間帯」
              var parts = String(value || '').split(' |&| ');
              var title = parts[0] || '';
              attrs[key] = title + ' |&| ' + NO_DATE_VALUE + ' |&| ' + NO_DAY_VALUE + ' |&| ' + NO_TIME_VALUE;
              has = true;
            } else {
              // calendar_type や Date Format など他はそのまま維持
              attrs[key] = value;
            }
          }

          if (!has) return;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .catch(function (err) {
          if (window.console && console.warn) {
            console.warn('Failed to rewrite cart product_ attributes', err);
          }
        });
    } catch (e) {
      // 何かあってもサイト全体が落ちないように握りつぶす
    }
  }

  // -----------------------------
  // 日付の「×」ボタン（container = .identixweb-order-delivery）
  // -----------------------------
function setupDateClear(container) {
  var groups = container.querySelectorAll('.odd-input-group');
  if (!groups.length) return;

  groups.forEach(function (group) {
    var input = group.querySelector('input.uiDeliveryCalendar');
    if (!input) return;

    // 既にボタンがあればスキップ
    if (group.querySelector('.delivery-date-clear')) return;

    var hiddenDate  = container.querySelector('.uiDeliveryDateVal');
    var hiddenDay   = container.querySelector('.deliveryDayValue');
    var hiddenTime  = container.querySelector('.uiDeliveryTimeVal');
    var hiddenTime2 = container.querySelector('.deliverytimeValues');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'delivery-date-clear';
    btn.innerHTML = '×';

    // ★ ここからクリック処理
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // いま表示されている日付を控えておく（アプリが戻そうとする値）
      var prevVal = input.value || '';

      // 1) 表示クリア
      input.value = '';

      // 2) hidden 値を「指定しない」系で潰す
      if (hiddenDate)  hiddenDate.value  = NO_DATE_VALUE;
      if (hiddenDay)   hiddenDay.value   = NO_DAY_VALUE;
      if (hiddenTime)  hiddenTime.value  = NO_TIME_VALUE;
      if (hiddenTime2) hiddenTime2.value = NO_TIME_VALUE;

      // 3) 時間帯セレクトのラベルも「指定しない」に戻す
      var timeSelect = container.querySelector(
        '.ant-select.identixweb-order-delivery-deliveryTime'
      );
      if (timeSelect) {
        var labelSpan = timeSelect.querySelector(
          '.ant-select-selection-item, .ant-select-selection-placeholder'
        );
        if (labelSpan) {
          var placeholder =
            timeSelect.getAttribute('data-time-placeholder') ||
            labelSpan.getAttribute('data-original-text') ||
            NO_TIME_VALUE;
          labelSpan.textContent = placeholder;
        }
      }

      // 4) アプリ側へイベント
      ['input', 'change'].forEach(function (type) {
        var ev = new Event(type, { bubbles: true });
        input.dispatchEvent(ev);
        [hiddenDate, hiddenDay, hiddenTime, hiddenTime2].forEach(function (el) {
          if (el) el.dispatchEvent(ev);
        });
      });

      // 5) ストレージ掃除
      clearDeliveryStorage();

      // 6) cart attributes.product_* を NaN / 指定しない で更新
      rewriteCartProductAttributesToNone();

      // 7) ★ ガード：古い日付が勝手に復活してきたら、もう一度消す
      if (prevVal && prevVal.trim()) {
        var start = Date.now();
        var guardTimer = setInterval(function () {
          var now = Date.now();
          // 最大 5 秒だけ監視
          if (now - start > 5000) {
            clearInterval(guardTimer);
            return;
          }

          var v = input.value || '';

          // まだ空欄なら何もしない（正常）
          if (!v.trim()) return;

          // アプリが「元の値」を戻してきた場合 → 再度クリア
          if (v === prevVal) {
            input.value = '';

            // 念のため hidden 側ももう一度「指定しない」にしておく
            if (hiddenDate)  hiddenDate.value  = NO_DATE_VALUE;
            if (hiddenDay)   hiddenDay.value   = NO_DAY_VALUE;
            if (hiddenTime)  hiddenTime.value  = NO_TIME_VALUE;
            if (hiddenTime2) hiddenTime2.value = NO_TIME_VALUE;
            return;
          }

          // ここまで来たら「別の値」＝ユーザーが新しく日付を選んだと判断してガード終了
          clearInterval(guardTimer);
        }, 200);
      }
    });
    // ★ クリック処理ここまで

    group.appendChild(btn);
  });
}

  // -----------------------------
  // 時間帯の「×」ボタン
  // -----------------------------
  function setupTimeClear(container) {
    var selects = container.querySelectorAll(
      '.ant-select.identixweb-order-delivery-deliveryTime'
    );
    if (!selects.length) return;

    selects.forEach(function (select) {
      // 既にボタンがあればスキップ
      if (select.querySelector('.delivery-time-clear')) return;

      var hiddenTime  = container.querySelector('.uiDeliveryTimeVal');
      var hiddenTime2 = container.querySelector('.deliverytimeValues');

      var labelSpan = select.querySelector(
        '.ant-select-selection-item, .ant-select-selection-placeholder'
      );
      if (!labelSpan) return;

      // 初期プレースホルダーを保存（後で戻すのに使う）
      if (!select.getAttribute('data-time-placeholder')) {
        select.setAttribute(
          'data-time-placeholder',
          labelSpan.textContent || NO_TIME_VALUE
        );
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'delivery-time-clear';
      btn.innerHTML = '×';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        // 1) hidden を「時間帯を指定しない」に
        if (hiddenTime)  hiddenTime.value  = NO_TIME_VALUE;
        if (hiddenTime2) hiddenTime2.value = NO_TIME_VALUE;

        // 2) 表示ラベルも「時間帯を指定しない」相当に戻す
        var placeholder = select.getAttribute('data-time-placeholder') || NO_TIME_VALUE;
        var text = placeholder.indexOf('指定しない') !== -1 ? placeholder : NO_TIME_VALUE;
        if (labelSpan) {
          labelSpan.textContent = text;
        }

        select.classList.add('ev-no-time');

        // 3) アプリ側へイベント（hidden にも change を飛ばしておく）
        ['input', 'change'].forEach(function (type) {
          var ev = new Event(type, { bubbles: true });
          if (hiddenTime)  hiddenTime.dispatchEvent(ev);
          if (hiddenTime2) hiddenTime2.dispatchEvent(ev);
        });

        // 4) line item properties（ご希望の時間帯）がフォームにあれば同期
        var form = container.closest('form');
        if (form) {
          var props = form.querySelectorAll('input[name^="properties["]');
          props.forEach(function (el) {
            var name = el.name || '';
            if (/ご希望の時間帯/.test(name)) {
              el.value = NO_TIME_VALUE;
              ['input', 'change'].forEach(function (type) {
                var ev2 = new Event(type, { bubbles: true });
                el.dispatchEvent(ev2);
              });
            }
          });
        }

        // 5) ストレージ掃除
        clearDeliveryStorage();

        // 6) アプリ本体の Select に対しても option を選択
        forceSelectNoTimeOption(select);

        // 7) 🔑 cart attributes.product_* を NaN / 指定しない で更新
        rewriteCartProductAttributesToNone();
      });

      select.appendChild(btn);
    });
  }

  // -----------------------------
  // グローバル監視：
  // hiddenDate が NaN-aN-aN の間は、入力欄を常に「指定しない」状態に保つ
  // -----------------------------
  function enforceNoneState() {
    var containers = document.querySelectorAll('.identixweb-order-delivery');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var hiddenDate = container.querySelector('.uiDeliveryDateVal');
      var group     = container.querySelector('.odd-input-group');
      var dateInput = group && group.querySelector('input.uiDeliveryCalendar');

      if (!hiddenDate || !group || !dateInput) return;

      if (hiddenDate.value === NO_DATE_VALUE) {
        // 「×」でクリアした状態 → マスクON
        if (dateInput.value !== '') {
          dateInput.value = '';  // ロジック的にも空にしておく
        }
        group.classList.add('ev-none-active');
      } else {
        // それ以外（= 日付が入っている）→ マスクOFF
        group.classList.remove('ev-none-active');
      }
    });
  }

  // -----------------------------
  // 画面全体に対して一括セットアップ（商品ページ＆カート両方）
  // -----------------------------
  function setupAll() {
    var containers = document.querySelectorAll('.identixweb-order-delivery');
    if (!containers.length) return;

    containers.forEach(function (container) {
      setupDateClear(container);
      setupTimeClear(container);
    });
  }

  // 初期ロード
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll();
    }, { once: true });
  } else {
    setupAll();
  }

  // 後から描画されるパーツ対策（ドロワーカートなど）
  var tries = 0;
  var timer = setInterval(function () {
    setupAll();
    tries++;
    if (tries >= 10) clearInterval(timer);
  }, 800);

  var observer = new MutationObserver(function (mutations) {
    var needSetup = false;

    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (
          (node.matches && node.matches('.identixweb-order-delivery, .identixweb-order-delivery *')) ||
          (node.querySelector && node.querySelector('.identixweb-order-delivery'))
        ) {
          needSetup = true;
        }
      });
    });

    if (needSetup) {
      setupAll();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // -----------------------------
  // Add to Cart の「その一発」だけを確実に書き換える（既存のまま）
  // -----------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'form[action*="/cart/add"] [type="submit"], ' +
      'button[name="add"], ' +
      '.product-form button[type="submit"]'
    );
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;

    // このフォーム内の Delivery & Pickup ウィジェットだけ見る
    var container = form.querySelector('.identixweb-order-delivery');
    if (!container) return;

    var dateInput   = container.querySelector('input.uiDeliveryCalendar');
    var hiddenDate  = container.querySelector('.uiDeliveryDateVal');
    var hiddenDay   = container.querySelector('.deliveryDayValue');
    var hiddenTime  = container.querySelector('.uiDeliveryTimeVal');
    var hiddenTime2 = container.querySelector('.deliverytimeValues');

    var dateEmpty = !dateInput || !String(dateInput.value).trim();

    // 日付：空なら NaN-aN-aN / 曜日空
    if (dateEmpty) {
      if (hiddenDate) hiddenDate.value = NO_DATE_VALUE;
      if (hiddenDay)  hiddenDay.value  = NO_DAY_VALUE;
    }

    // 時間帯：ラベルから「指定なし」判定
    var timeSelect = container.querySelector('.ant-select.identixweb-order-delivery-deliveryTime');
    var labelSpan = timeSelect && timeSelect.querySelector(
      '.ant-select-selection-item, .ant-select-selection-placeholder'
    );
    var labelText = labelSpan ? (labelSpan.textContent || '').trim() : '';
    var placeholder = timeSelect
      ? (timeSelect.getAttribute('data-time-placeholder') || '')
      : '';

    var isTimeNone =
      !labelText ||
      labelText === NO_TIME_VALUE ||
      labelText.indexOf('指定しない') !== -1 ||
      labelText.indexOf('選択しない') !== -1 ||
      labelText === 'ご希望の時間帯を選択' ||
      (placeholder && labelText === placeholder);

    if (isTimeNone) {
      if (hiddenTime)  hiddenTime.value  = NO_TIME_VALUE;
      if (hiddenTime2) hiddenTime2.value = NO_TIME_VALUE;
    }

    // line item properties（日本語ラベル）も念のため補正
    var props = form.querySelectorAll('input[name^="properties["]');
    props.forEach(function (el) {
      var name = el.name;

      if (/お届け希望日/.test(name) && dateEmpty) {
        el.value = NO_DATE_VALUE;
      }

      if (/ご希望の時間帯/.test(name) && isTimeNone) {
        el.value = NO_TIME_VALUE;
      }
    });

    // 念のためストレージも掃除
    clearDeliveryStorage();
  }, true); // capture フェーズで先に実行

  // hiddenDate が NaN-aN-aN の間は、常に「表示上は 指定しない」に戻す
  setInterval(enforceNoneState, 400);

})();

// =====================================================================================
// rmdp（react-modern-datepicker）のヘッダー微調整（ここは前と同じ）
// =====================================================================================
(function () {
  const HEADER_SEL = '.rmdp-header-values';
  const YEAR_STYLE = HEADER_SEL + ' span:nth-child(2){font-size:0.8em !important; font-weight:500 !important;}';

  const styledRoots = new WeakSet();
  const observedRoots = new WeakSet();

  function ensureStyle(root) {
    if (styledRoots.has(root)) return;
    var style = document.createElement('style');
    style.textContent = YEAR_STYLE;
    if (root && root.nodeType === 11) { // ShadowRoot
      root.appendChild(style);
    } else {
      document.head.appendChild(style);
    }
    styledRoots.add(root || document);
  }

  function stripComma(headerEl) {
    var first = headerEl.querySelector('span:first-child');
    if (!first) return;
    var before = first.textContent || '';
    var after  = before.replace(/[,，]\s*$/, '');
    if (after !== before) first.textContent = after;
  }

  function tweakInRoot(root) {
    ensureStyle(root);
    var headers = root.querySelectorAll ? root.querySelectorAll(HEADER_SEL) : [];
    headers.forEach(stripComma);
  }

  function forEachShadowRoot(root, cb) {
    cb(root);
    var base = root.querySelectorAll ? root : document;
    var all = base.querySelectorAll ? base.querySelectorAll('*') : [];
    all.forEach(function (el) {
      if (el.shadowRoot) {
        cb(el.shadowRoot);
        forEachShadowRoot(el.shadowRoot, cb);
      }
    });
  }

  function forEachSameOriginIframe(cb) {
    var iframes = document.querySelectorAll('iframe');
    iframes.forEach(function (iframe) {
      try {
        var doc = iframe.contentDocument;
        if (doc) cb(doc);
      } catch (e) {
        // 異なるオリジンは無視
      }
    });
  }

  function scanAll() {
    forEachShadowRoot(document, function (root) { tweakInRoot(root); });
    forEachSameOriginIframe(function (doc) {
      tweakInRoot(doc);
      forEachShadowRoot(doc, function (sr) { tweakInRoot(sr); });
    });
  }

  function observeRoot(root) {
    if (observedRoots.has(root)) return;
    var target = (root === document) ? document.documentElement : root;
    var mo = new MutationObserver(function () { tweakInRoot(root); });
    mo.observe(target, { subtree: true, childList: true, characterData: true });
    observedRoots.add(root);
  }

  function observeAll() {
    observeRoot(document);
    forEachShadowRoot(document, function (sr) { observeRoot(sr); });
    forEachSameOriginIframe(function (doc) {
      observeRoot(doc);
      forEachShadowRoot(doc, function (sr) { observeRoot(sr); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanAll();
      observeAll();
    }, { once: true });
  } else {
    scanAll();
    observeAll();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest &&
        e.target.closest('.prev_header_btn, .next_header_btn, .prev_next_button')) {
      requestAnimationFrame(scanAll);
      setTimeout(scanAll, 100);
    }
  }, true);
})();

// =====================================================================================
// 表示上の「NaN-aN-aN」「時間帯を指定しない」を「指定しない」に置き換え（見た目だけ）
// =====================================================================================
(function () {

  function replaceNoneLabels(root) {
    root = root || document.body;
    if (!root) return;

    // テキストノードを走査して、該当する文字列だけ差し替える
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      // script / style 内は変更しない
      var parent = node.parentNode;
      if (!parent || !parent.tagName) continue;
      var tag = parent.tagName.toLowerCase();
      if (tag === 'script' || tag === 'style' || tag === 'noscript') continue;

      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      if (!text) return;

      var replaced = text
        .replace(/NaN-aN-aN/g, '指定しない')
        .replace(/時間帯を指定しない/g, '指定しない');

      if (replaced !== text) {
        textNode.nodeValue = replaced;
      }
    });
  }

  // 初回ロード時
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        replaceNoneLabels(document.body);
      },
      { once: true }
    );
  } else {
    replaceNoneLabels(document.body);
  }

  // ドロワーカートなど、後から追加される要素にも対応
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          replaceNoneLabels(node);
        }
      });
    });
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// =====================================================================================
// 商品タイトルの「｜」を <br> に変換（商品ページ＋コレクショングリッド）
// =====================================================================================
(function () {

  // -- 内部 helper: 指定セレクタ群に対して「｜」→ <br> を適用 --
  function applyMultiLineTitlesInRoot(root) {
    root = root || document;
    if (!root.querySelectorAll) return;

    // 対象となる「タイトルのラッパ」セレクタ
    var SELECTORS = [
      '.product-details-product-title', // 商品ページの h1
      '.product-card-basic__title',     // Flow の product-card-basic
      '.product-grid--title'            // コレクショングリッド（今回の HTML）
    ];

    SELECTORS.forEach(function (selector) {
      var wrappers = root.querySelectorAll(selector);
      if (!wrappers.length) return;

      wrappers.forEach(function (wrapper) {
        // aタグ内にタイトルが入っている場合を優先
        var target = wrapper.querySelector('a') || wrapper;
        if (!target) return;

        var text = (target.textContent || '').trim();
        if (!text || text.indexOf('｜') === -1) return; // 全角「｜」が無ければ何もしない

        // Flow の 1行省略クラスが付いていると改行が効きにくいので外す
        try {
          target.classList.remove('text-truncate--line');
        } catch (e) {}

        // 「｜」で分割 → 前後のスペースを除去 → 空文字は捨てる
        var parts = text
          .split('｜')
          .map(function (part) { return part.trim(); })
          .filter(function (part) { return part.length > 0; });

        if (!parts.length) return;

        // <br> で結合して表示
        target.innerHTML = parts.join('<br>');
      });
    });
  }

  // -- 初期実行 --
  function runAll() {
    try {
      applyMultiLineTitlesInRoot(document);
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('applyMultiLineTitles failed', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () { runAll(); },
      { once: true }
    );
  } else {
    runAll();
  }

  // -- 後から追加される要素（AJAX, ドロワーなど）にも対応 --
  var mo = new MutationObserver(function (mutations) {
    var need = false;

    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          (node.matches && node.matches('.product-details-product-title, .product-card-basic__title, .product-grid--title')) ||
          (node.querySelector && node.querySelector('.product-details-product-title, .product-card-basic__title, .product-grid--title'))
        ) {
          need = true;
        }
      });
    });

    if (need) {
      runAll();
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();



// =====================================================================================
// コレクションリストの「もっと見る 〇〇」の語順修正 (重複実行防止版)
// =====================================================================================
(function() {
  var timer = null;

  function fixCollectionLinks() {
    var moreLinks = document.querySelectorAll('.list-collections--more-link a span, .list-collections--more-link a span.animated-underline');

    moreLinks.forEach(function(span) {
      var originalText = span.textContent.trim();

      // ★追加: すでに「をもっと見る」で終わっている場合は、修正済みなので何もしない
      // (これで「ををを...」と増えるのを防ぎます)
      if (originalText.slice(-6) === 'をもっと見る') {
        return;
      }

      // 「もっと見る」が先頭にある場合のみ処理する (例:「もっと見る ground²coffee」)
      if (originalText.indexOf('もっと見る') === 0) {
        // 「もっと見る」を削除してコレクション名だけ取得
        var collectionName = originalText.replace('もっと見る', '').trim();

        if (collectionName) {
          span.textContent = collectionName + ' をもっと見る';
        }
      }
      // 英語対応など
      else if (originalText.indexOf('See more') === 0) {
        // 必要ならここに処理
      }
    });
  }

  // 初期ロード時
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCollectionLinks);
  } else {
    fixCollectionLinks();
  }

  // 動的な変更を監視 (軽量化版)
  var observer = new MutationObserver(function(mutations) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function() {
      fixCollectionLinks();
    }, 500); 
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();